import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    AppStoreIconWrapper,
    FooterList,
    GooglePlayIconWrapper,
    StoreAppLinks,
} from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/getTheApp/GetTheApp.style';
import { FooterHeader } from 'src/domains/layouts/webview/modules/layoutSkeleton/footer/content/FooterContent.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { EnvironmentState } from 'src/domains/layouts/state/environmentState/EnvironmentState';

export const GetTheApp = observer('GetTheApp', (): JSX.Element | null => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const env = EnvironmentState.get(common);
    const {
        appDownloadLink: { appStoreLink, googlePlayLink },
    } = configComponents.config;

    if (appStoreLink === null && googlePlayLink === null) {
        return null;
    }

    if (env.isMobileApp() === true) {
        return null;
    }

    return (
        <>
            <FooterHeader>
                <I18n
                    langKey='footer.get-app'
                    defaultText='Get the App'
                />
            </FooterHeader>

            <FooterList>
                {appStoreLink === null ? null : (
                    <StoreAppLinks to={appStoreLink}>
                        <AppStoreIconWrapper />
                    </StoreAppLinks>
                )}

                {googlePlayLink === null ? null : (
                    <StoreAppLinks to={googlePlayLink}>
                        <GooglePlayIconWrapper />
                    </StoreAppLinks>
                )}
            </FooterList>
        </>
    );
});
